module.exports = __webpack_public_path__ + "static/media/codigo.09392299.png";